import React from 'react'

export default function PayrollStats(props) {
    const { overallCount } = props;

    function limitToTwoDecimal(number) {
        return number ? (Math.round(number * 100) / 100) : '000.00';
    }

    return (
        <div className="align-items-center">
            <div className='row justify-content-around'>
                <div className='col-lg-12 col-md-12 d-flex justify-content-center mt-0 mt-md-3 mt-lg-3 mt-xl-3 gap-3 overViewWages_Responsive' style={{ transform: "translate(-62px, 0px)" }}>
                    <div className=" sechudleCard default_color">
                        <p>Care Team</p>
                        <h5>{overallCount?.totalCareTeam}</h5>
                    </div>
                    <div className=" sechudleCard" style={{ color: '#2D9CDB' }}>
                        <p>Regular Hrs</p>
                        <h5>{overallCount?.totalRegularHours?.toFixed(2)}</h5>
                    </div>
                    <div className=" sechudleCard" style={{ color: '#F2C94C' }}>
                        <p>Overtime Hrs </p>
                        <h5>{overallCount?.totalOverTimeHours?.toFixed(2)}</h5>
                    </div>
                    <div className=" sechudleCard" style={{ color: '#F2994A' }}>
                        <p>Total Hrs</p>
                        <h5>{overallCount?.totalHours?.toFixed(2)}</h5>
                    </div>
                    <div className=" sechudleCard" style={{ color: '#27AE60' }}>
                        <p>Wages</p>
                        <h5>£  {limitToTwoDecimal(overallCount?.totalGrossWages)}</h5>
                    </div>
                </div>
            </div>
        </div>
    )
}
